{
    "Profile_InsuranceApplicant.contactDetails": "Applicant Contact Details (Mortgage Broker, Lawyer, Other)",
    "Profile_InsuranceApplicant.enterContactInformation": "Applicant Contact Information",
    "Profile_InsuranceApplicant.realEstateAgentContactDetails": "Real Estate Agent Contact Details",
    "Profile_InsuranceApplicant.realEstateAgentContactInformation": "Real Estate Agent Contact Information",
    "Profile_InsuranceApplicant.buyerContactDetails": "Buyer Contact Details",
    "Profile_InsuranceApplicant.buyerContactInformation": "Buyer Contact Information",
    "Profile_InsuranceApplicant.buyerOfferStatus": "Offer Status",
    "Profile_InsuranceApplicant.buyerOfferStatusDetails": "Buyer Offer Status",
    "Profile_InsuranceApplicant.additionalInfo": "Additional Info",
    "Profile_InsuranceApplicant.guestPartner": "Guest Partner",
    "Profile_InsuranceApplicant.guestPartnerInformation": "Guest Partner Contact Information",
    "Profile_InsuranceApplicant.certificateInformation": "Certificate Information",
    "Profile_InsuranceApplicant.certificateOwnerType": "Certificate Owner Type",
    "Profile_InsuranceApplicant.firstName": "First Name",
    "Profile_InsuranceApplicant.lastName": "Last Name",
    "Profile_InsuranceApplicant.email": "Email",
    "Profile_InsuranceApplicant.phoneNumber": "Phone Number",
    "Profile_InsuranceApplicant.relationshipToSeller": "Relationship to Seller",
    "Profile_InsuranceApplicant.whatIsRelationship": "What is your relationship to the seller?",
    "Profile_InsuranceApplicant.isSeller": "Are you the seller?",
    "Profile_InsuranceApplicant.relationship": "Relationship",
    "Profile_InsuranceApplicant.other": "Other",
    "Profile_InsuranceApplicant.estimatedSalePrice": "Estimated Sale Price",
    "Profile_InsuranceApplicant.minExpectedSaleAmount": "Min Expected Sale Amount",
    "Profile_InsuranceApplicant.maxExpectedSaleAmount": "Max Expected Sale Amount",
    "Profile_InsuranceApplicant.minAmountFormatted": "Pre-Approval Range Min Amount",
    "Profile_InsuranceApplicant.maxAmountFormatted": "Pre-Approval Range Max Amount",
    "Profile_InsuranceApplicant.preApprovalRangeMinAmountOverride": "Pre-Approval Range Min Amount Override",
    "Profile_InsuranceApplicant.preApprovalRangeMaxAmountOverride": "Pre-Approval Range Max Amount Override",
    "Profile_InsuranceApplicant.intendedOfferAmount": "Intended Offer Amount"
}
